import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78009fe8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "tier-table-scroll",
  ref: "tierTableScroll"
}
const _hoisted_2 = { class: "tier-table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tier-table__header-column-name" }, "Basic", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "tier-table__header-column-name" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "tier-table__header-column-name" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "tier-table__current-plan_column-name"
}
const _hoisted_12 = {
  key: 0,
  class: "tier-table__current-plan_column-name"
}
const _hoisted_13 = {
  key: 1,
  class: "tier-table__recommended_column-name"
}
const _hoisted_14 = {
  key: 0,
  class: "tier-table__current-plan_column-name"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "primary-color" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6 9l6 6 6-6",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_18 = { class: "tier-table__feature-list" }
const _hoisted_19 = { class: "tier-table__feature-name" }
const _hoisted_20 = { class: "w-100 text-wrap" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "tier-table__check",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_23 = {
  key: 2,
  class: "tier-table__check--off",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M6 12h12",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 1,
  class: "tier-table__check",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_28 = {
  key: 2,
  class: "tier-table__check--off",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M6 12h12",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 1,
  class: "tier-table__check",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_33 = {
  key: 2,
  class: "tier-table__check--off",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M6 12h12",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_35 = [
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["tier-table-section", { 'tier-table-section--right-shadow': _ctx.isRightShadowVisible,  'tier-table-section--left-shadow': _ctx.isLeftShadowVisible }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["tier-table__header", { 'tier-table__column--show_trial' : _ctx.showTrial, 'tier-table__column--no_trial' : !_ctx.showTrial, 'p-0' : !_ctx.subscriptionPlan}])
        }, [
          _hoisted_3,
          _createElementVNode("div", {
            class: _normalizeClass(["tier-table__header-column", { 'tier-table__header-column--active': _ctx.subscriptionPlan == 'basic' }])
          }, _hoisted_5, 2),
          _createElementVNode("div", {
            class: _normalizeClass([{ 'tier-table__header-column--active': _ctx.subscriptionPlan == 'premium', 'recommended__header-border': _ctx.showRecommended}, "tier-table__header-column"])
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createTextVNode("Premium"),
              _createElementVNode("img", {
                class: "logo--x-large ms-1 mb-1 me-0",
                src: require('../assets/images/ditto-tier-logo-gray.png')
              }, null, 8, _hoisted_7)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["tier-table__header-column", { 'tier-table__header-column--active': _ctx.subscriptionPlan == 'elite' || _ctx.subscriptionPlan == 'trial' }])
          }, [
            _createElementVNode("span", _hoisted_8, [
              _createTextVNode("Elite"),
              _createElementVNode("img", {
                class: "logo--x-large ms-1 mb-1 me-0",
                src: require('../assets/images/ditto-tier-logo-gold.png')
              }, null, 8, _hoisted_9)
            ])
          ], 2)
        ], 2),
        (_ctx.subscriptionPlan)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["tier-table__current-plan", { 'tier-table__column--show_trial' : _ctx.showTrial, 'tier-table__column--no_trial' : !_ctx.showTrial, 'p-0' : !_ctx.subscriptionPlan}])
            }, [
              _hoisted_10,
              _createElementVNode("div", {
                class: _normalizeClass(["tier-table__current-plan_column", { 'tier-table__column--active': _ctx.subscriptionPlan == 'basic' }])
              }, [
                (_ctx.subscriptionPlan === 'basic')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Current Plan"))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["tier-table__current-plan_column", { 'tier-table__column--active': _ctx.subscriptionPlan == 'premium', 'recommended__side-border': _ctx.showRecommended, 'tier-table__recommended_column': _ctx.showRecommended}])
              }, [
                (_ctx.subscriptionPlan === 'premium')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Current Plan"))
                  : _createCommentVNode("", true),
                (_ctx.showRecommended)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Recommended"))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["tier-table__current-plan_column", { 'tier-table__column--active': _ctx.subscriptionPlan == 'elite' || _ctx.subscriptionPlan == 'trial' }])
              }, [
                (_ctx.subscriptionPlan === 'elite' || _ctx.subscriptionPlan == 'trial')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Current Plan"))
                  : _createCommentVNode("", true)
              ], 2)
            ], 2))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.featureCategories, (category, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
            _createElementVNode("div", {
              onClick: ($event: any) => (_ctx.toggleTableRow(i)),
              class: _normalizeClass(["tier-table__section-title-row", { 'tier-table__section-title-row--expanded': category.isExpanded }])
            }, [
              _createElementVNode("span", _hoisted_16, _toDisplayString(category.categoryName), 1),
              _hoisted_17
            ], 10, _hoisted_15),
            _createVNode(_Transition, {
              mode: "out-in",
              onBeforeEnter: _ctx.beforeEnter,
              onEnter: _ctx.enter,
              onLeave: _ctx.leave,
              css: false
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", {
                  ref_for: true,
                  ref: "tableOuter",
                  class: "tier-table__section"
                }, [
                  _createElementVNode("ul", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.features, (feature, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: _normalizeClass(["tier-table__feature-item", { 'tier-table__column--show_trial' : _ctx.showTrial, 'tier-table__column--no_trial' : !_ctx.showTrial}]),
                        key: feature.name
                      }, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createTextVNode(_toDisplayString(feature.name) + " ", 1),
                            (feature.description)
                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                  key: 0,
                                  placement: "top",
                                  "show-after": 0,
                                  "hide-after": 0
                                }, {
                                  content: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(feature.description), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_Icon, {
                                      class: "icon icon--small icon--info me-2",
                                      icon: _ctx.mdiInformationOutline
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["tier-table__column tier-table__column--basic", { 'tier-table__column--active': _ctx.subscriptionPlan == 'basic' }])
                        }, [
                          (category.categoryName === 'Limits')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.getLimit(feature.plans, 'basic', feature.id)), 1))
                            : (_ctx.checkFeature(feature.plans, 'basic'))
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_22, [
                                  (!feature.addOnFeature)
                                    ? (_openBlock(), _createBlock(_component_Icon, {
                                        key: 0,
                                        class: "icon icon--large icon--info me-2",
                                        icon: _ctx.mdiCheck
                                      }, null, 8, ["icon"]))
                                    : (feature.addOnFeature)
                                      ? (_openBlock(), _createBlock(_component_Icon, {
                                          key: 1,
                                          class: "icon icon--large icon--info me-2",
                                          icon: _ctx.mdiCurrencyUsd
                                        }, null, 8, ["icon"]))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("svg", _hoisted_23, _hoisted_25))
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["tier-table__column tier-table__column--premium", { 'tier-table__column--active': _ctx.subscriptionPlan == 'premium', 'recommended__side-border': _ctx.showRecommended, 'recommended__bottom-border': _ctx.showRecommended && index == category.features.length - 1, 'recommended__top-border': _ctx.showRecommended && index == 0}])
                        }, [
                          (category.categoryName === 'Limits')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.getLimit(feature.plans, 'premium', feature.id)), 1))
                            : (_ctx.checkFeature(feature.plans, 'premium'))
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_27, [
                                  (!feature.addOnFeature)
                                    ? (_openBlock(), _createBlock(_component_Icon, {
                                        key: 0,
                                        class: "icon icon--large icon--info me-2",
                                        icon: _ctx.mdiCheck
                                      }, null, 8, ["icon"]))
                                    : (feature.addOnFeature)
                                      ? (_openBlock(), _createBlock(_component_Icon, {
                                          key: 1,
                                          class: "icon icon--large icon--info me-2",
                                          icon: _ctx.mdiCurrencyUsd
                                        }, null, 8, ["icon"]))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("svg", _hoisted_28, _hoisted_30))
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["tier-table__column tier-table__column--elite", { 'tier-table__column--active': _ctx.subscriptionPlan == 'elite' || _ctx.subscriptionPlan == 'trial' }])
                        }, [
                          (category.categoryName === 'Limits')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.getLimit(feature.plans, 'elite', feature.id)), 1))
                            : (_ctx.checkFeature(feature.plans, 'elite'))
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_32, [
                                  (!feature.addOnFeature)
                                    ? (_openBlock(), _createBlock(_component_Icon, {
                                        key: 0,
                                        class: "icon icon--large icon--info me-2",
                                        icon: _ctx.mdiCheck
                                      }, null, 8, ["icon"]))
                                    : (feature.addOnFeature)
                                      ? (_openBlock(), _createBlock(_component_Icon, {
                                          key: 1,
                                          class: "icon icon--large icon--info me-2",
                                          icon: _ctx.mdiCurrencyUsd
                                        }, null, 8, ["icon"]))
                                      : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("svg", _hoisted_33, _hoisted_35))
                        ], 2)
                      ], 2))
                    }), 128))
                  ])
                ], 512), [
                  [_vShow, category.isExpanded]
                ])
              ]),
              _: 2
            }, 1032, ["onBeforeEnter", "onEnter", "onLeave"])
          ], 64))
        }), 128))
      ])
    ], 512)
  ], 2))
}